export default __webpack_public_path__ + "static/media/ecommerce.bbea9a02.svg";